import { render, staticRenderFns } from "./TagDetail.vue?vue&type=template&id=f8a56fb8&scoped=true&"
import script from "./TagDetail.vue?vue&type=script&lang=js&"
export * from "./TagDetail.vue?vue&type=script&lang=js&"
import style0 from "./TagDetail.vue?vue&type=style&index=0&id=f8a56fb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a56fb8",
  null
  
)

export default component.exports